"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.BottomToolbar = props => {
    const { left, right, children, className } = props;
    return (react_1.default.createElement(react_2.Portal, { elementID: "footer-portal" },
        react_1.default.createElement(reactstrap_1.Row, null,
            react_1.default.createElement(reactstrap_1.Col, null,
                react_1.default.createElement(reactstrap_1.Row, { className: `text-right bg-dark shadow-sm-top ${className || ''}` }, !children ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(reactstrap_1.Col, { className: "m-1 ml-2 d-flex text-center" }, left),
                    react_1.default.createElement(reactstrap_1.Col, { className: "col-sm col-sm-auto m-2 ml-1" }, right))) : (react_1.default.createElement(reactstrap_1.Col, { className: "mx-1" }, children)))))));
};
//# sourceMappingURL=BottomToolbar.js.map